import React from 'react';
import PropTypes from 'prop-types';
import { BodyText, HeadingText } from '@paypalcorp/pp-react';
import CollectionHeader from '../../components/CollectionHeader';
import CollectionSection from '../../components/CollectionSection';
import { parseData } from '../../../../lib/helpers';

import { AMPLITUDE } from '../../../../lib/constants';

const { COLLECTION_IMPRESSION } = AMPLITUDE;

class Collection extends React.Component {
  componentDidMount() {
    const {
      fptiImpression,
      location: { pathname = '' }
    } = this.props;
    this.collectionLocation = pathname.split('/').pop();

    fptiImpression({
      amplitude: true,
      event_name: COLLECTION_IMPRESSION
    });
  }

  renderCollection = () => {
    const {
      collection,
      flatPSData: { tools = {} },
      toolTileProps,
      fptiClick,
      fptiImpression,
      structuredPSData
    } = this.props;
    const { categories = [] } = structuredPSData;
    const { sections, ideas, ideasTitle, fptiLinkName } = collection;
    const parsedSections = parseData(sections);
    const parsedIdeas = parseData(ideas);
    const locationByCategoryKey = categories.reduce((acc, curr) => {
      const categoryKey = curr.content.categoryKey;
      acc[categoryKey] = curr.content.location;
      return acc;
    }, {});

    const handleClickFPTI = idea => {
      const options = { type: fptiLinkName || '', pageLink: idea.fptiLinkName };

      fptiClick(options);
    };
    return (
      <div className="collection">
        <CollectionHeader
          collection={collection}
          structuredPSData={structuredPSData}
        />
        <section className="sections">
          {parsedSections.map(section => {
            return (
              <CollectionSection
                section={section}
                collection={collection}
                toolTileProps={toolTileProps}
                tools={tools}
                locationByCategoryKey={locationByCategoryKey}
                fptiClick={fptiClick}
                fptiImpression={fptiImpression}
                structuredPSData={structuredPSData}
              />
            );
          })}
        </section>
        <section className="collection-ideas sections">
          <div className="collection-ideas-title">
            <HeadingText level={2} >{ideasTitle}</HeadingText>
          </div>
          <div className="section-tools">
            {parsedIdeas.map((idea, i) => (
              <div
                key={`collection-idea-${i}`}
                className="collection-idea-container-item"
              >
                <BodyText  className="collection-idea-desc">{idea.description}</BodyText>
                <a
                  className="collection-idea-cta"
                  href={idea.cta}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => handleClickFPTI(idea)}
                >
                  {idea.ctaText}
                </a>
              </div>
            ))}
          </div>
        </section>
      </div>
    );
  };

  render() {
    return <div id="appcenter-collection">{this.renderCollection()}</div>;
  }
}

Collection.displayName = 'collection';

Collection.propTypes = {
  collection: PropTypes.object,
  fptiClick: PropTypes.func,
  flatPSData: PropTypes.object,
  structuredPSData: PropTypes.object,
  fptiImpression: PropTypes.func,
  location: PropTypes.shape({
    pathname: PropTypes.string
  }),
  toolTileProps: PropTypes.object
};

export default Collection;
